var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "the-section",
    { staticClass: "team", attrs: { legend: "Members", id: "tribe" } },
    _vm._l(_vm.team, function (member, index) {
      return _c("team-member", {
        key: member.id,
        attrs: { reverse: index % 2 !== 0, person: member },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }